import React, { Component, FunctionComponent } from "react";
import { ReduxActions } from "../store/login/loginTypes";

export interface IBadgeData {
  id: string;
  // Excell input data
  email: string;
  firstName: string;
  lastName: string;
  title: string;
  extraInfo?: string;
  startDate: string;
  endDate: string;
  // Brand and campaing data
  url: string;
  campaign: string;
  abbUniName: string;
  logo?: string;
  icon?: string;
  stampImage?: string;
}

export interface IBadgesTableData {
  id: string;
  href: string;
  data: {
    campaign: string;
    startDate: string;
    email: string;
    url: string;
    id: string;
    deletedAt?: string | null;
    createdAt: string;
  };
}
export interface ImageModel {
  src: string;
  alt: string;
}

export enum ActionStatusTypes {
  loading = "loading",
  success = "success",
  failed = "failed",
  neutral = "neutral",
}
export interface LinkModel {
  id?: string;
  label: string;
  route: string;
  outLink?: string;
  action?: (...args: any[]) => ReduxActions;
  icon?: ImageModel;
  iconComponent?: any;
  status?: string;
  subRoutes?: LinkModel[];
  selected?: boolean;
  scopes?: string[];
}

export interface StepModel {
  id: number;
  label: string;
  order: number;
  description?: string;
  route?: string;
  component?: Component | FunctionComponent | any;
  componentCredentialPreview?: Component | FunctionComponent | any;
  disabledInfo?: string;
}

export interface PaginationProps {
  currentPage: number;
  totalPages: number;
  boundaryPagesRange?: number;
  siblingPagesRange?: number;
  hideEllipsis?: boolean;
  hidePreviousAndNextPageLinks?: boolean;
  hideFirstAndLastPageLinks?: boolean;
  onChange?: (x?) => void;
  disabled?: boolean;
  totalItems?: number;
  pageSize?: number;
  className?: string;
}

// Pagination
export type PageItemType = "PAGE";
export type EllipsisItemType = "ELLIPSIS";
export type FirstPageLinkItemType = "FIRST_PAGE_LINK";
export type PreviousPageLinkItemType = "PREVIOUS_PAGE_LINK";
export type NextPageLinkItemType = "NEXT_PAGE_LINK";
export type LastPageLinkItemType = "LAST_PAGE_LINK";

export type PaginationItemType =
  | PageItemType
  | EllipsisItemType
  | FirstPageLinkItemType
  | PreviousPageLinkItemType
  | NextPageLinkItemType
  | LastPageLinkItemType;

export interface PaginationItemKeys {
  FIRST_ELLIPSIS: number;
  SECOND_ELLIPSIS: number;
  FIRST_PAGE_LINK: number;
  PREVIOUS_PAGE_LINK: number;
  NEXT_PAGE_LINK: number;
  LAST_PAGE_LINK: number;
  [type: string]: number;
}
export interface PaginationItemTypes {
  PAGE: PageItemType;
  ELLIPSIS: EllipsisItemType;
  FIRST_PAGE_LINK: FirstPageLinkItemType;
  PREVIOUS_PAGE_LINK: PreviousPageLinkItemType;
  NEXT_PAGE_LINK: NextPageLinkItemType;
  LAST_PAGE_LINK: LastPageLinkItemType;
}

export type DialogUse = "actionable" | "status";
export type DialogStatus = "success" | "error" | "warning";

export interface DialogProps {
  id?: string;
  use: DialogUse;
  title: string;
  contentText?: string;
  alert?: any;
  primaryButton?: any;
  secondaryButton?: any;
  status?: DialogStatus;
  list?: any;
  closableByBg?: boolean;
  onClose?: (x?: any) => void;
}

export interface IMediumModalProps {
  id?: string;
  title: string;
  description?: string;
  primaryButton?: any;
  secondaryButton?: any;
  closableByBg?: boolean;
  children?: React.ReactNode;
  onClose?: (x?: any) => void;
}

export interface ICreateBadgesResponse {
  badgesCreated?: IBadgeData[];
  validationErrors?: string[];
  creationError?: string;
}

export interface IIssuancePaginatedResponseModel {
  items: IBadgesTableData[];
  links: {
    last: string;
    next?: string;
    prev?: string;
  };
  pageSize: number;
  self: string;
  total: number;
}

export interface ISearchSelectorOptModel {
  text: string;
  value: string;
}
